import { configureStore } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import formModeReducer from './slices/formModeSlice'
import isFocusedReducer from './slices/focuseInputSlice'

const store = configureStore({
  reducer: {
    formMode: formModeReducer,
    isFocused: isFocusedReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default store
